export default "__VITE_ASSET__nxahy2pG__"